module.exports = __webpack_public_path__ + "img/symbol_8.3866fe4c.png";